import gql from 'graphql-tag';

export const GET_LOGBOOK_PAGE = gql`
  query ($id: ID!, $page: Int!){
    logbookGetPage(id: $id, page: $page)
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/queries/logbook/getPage.js